module.exports = __webpack_public_path__ + "c0bbba688a5c64d2d0af2b8660e5cffc.MP3";